/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ companyName: NonNullable<unknown> }} Coinvestments_Lp_Welcome_Landing_Browsedescription2Inputs */

const en_coinvestments_lp_welcome_landing_browsedescription2 = /** @type {(inputs: Coinvestments_Lp_Welcome_Landing_Browsedescription2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Explore co-investment opportunities ${i?.companyName} has made available to you`)
};

/**
* | output |
* | --- |
* | "Explore co-investment opportunities {companyName} has made available to you" |
*
* @param {Coinvestments_Lp_Welcome_Landing_Browsedescription2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lp_welcome_landing_browsedescription2 = /** @type {((inputs: Coinvestments_Lp_Welcome_Landing_Browsedescription2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lp_Welcome_Landing_Browsedescription2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lp_welcome_landing_browsedescription2(inputs)
});
export { coinvestments_lp_welcome_landing_browsedescription2 as "coInvestments_lp_welcome_landing_browseDescription" }